<template>
  <div class="menu-header-container">
    <div class="d-flex justify-space-between header-container">
      <div class="d-flex align-center pl-1">
        <v-icon class="pl-1 pr-2" color="secondary" style="width: 32px;">
          article
        </v-icon>
        <span class="reflection-title text-ellipsis">
          {{ reflection.title }}
        </span>
        <EditorToolbar
          v-if="!reflectionReadOnly"
          :editor="editor"
          :editor-focused-block="editorFocusedBlock"
          :reflection-id="reflection.id"
        />
      </div>
      <div class="d-flex justify-end">
        <ConnectedUsers :users="users" />
        <ACLModal
          v-if="!reflectionReadOnly"
          :document="reflection"
        >
          <template v-slot:button="{ activator }">
            <v-btn
              class="align-self-center ml-2"
              depressed
              small
              v-bind="activator.attrs"
              v-on="activator.on"
            >
              {{ $t('components.editor.share') }}
            </v-btn>
          </template>
        </ACLModal>

        <v-icon
          :color="signalColor()"
          class="material-icons mx-3"
          size="24"
        >
          sensors
        </v-icon>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ACLModal from '@/shared/components/dialog/ACLModal';
import EditorToolbar from './report/tiptap/EditorToolbar';
import ConnectedUsers from './report/tiptap/ConnectedUsers';
import { types } from '../../../store/rootTypes';

export default {
  name: 'ReflectionHeader',
  components: {
    ACLModal,
    EditorToolbar,
    ConnectedUsers,
  },
  props: {
    reflection: {
      type: Object,
      required: true,
    },
    editor: {
      type: Object,
      required: true,
    },
    editorStatus: {
      type: String,
      required: true,
    },
    editorFocusedBlock: {
      type: Object,
      required: false,
      default: undefined,
    },
    users: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      providerStatus: 'n/a',
    };
  },
  computed: {
    ...mapGetters({
      reflectionReadOnly: types.reflections.getters.reflectionReadOnly,
    }),
    template() {
      return this.reflection.template || {};
    },
    syncingMessage() {
      return `État de la connexion: ${this.editorStatus}`;
    },
  },
  methods: {
    signalColor() {
      if (this.editorStatus === 'synced') {
        return 'green';
      }
      return 'red';
    },
  },
};
</script>

<style scoped>
.header {
  min-height: 100px;
}

.reflectionDescription {
  font-size: 12px;
  margin: 0px;
  margin-left: 8px;
  color: #6E6D7B;
  max-width: 500px;
}

.reflectionDescription.empty {
  color: #999;
}

.text-ellipsis {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.editorWidth {
  width: 816px;
}

.actions {
  display: flex;
  justify-content: flex-end;
  align-items: flex-start;
  font-size: 16px;
}

.permissionsModalButton {
  width: 29px;
  height: 29px;
  border: 1px dashed #b5b5b5;
  margin: 0px;
  margin-bottom: 2px;
}
.header-container {
  background-color: white;
  border-bottom: 1px solid #ddd;
}
.menu-header-container {
  box-shadow: 0px 3px 5px #ddd;
  position: relative;
  z-index: 1;
}
.reflection-title {
  width: calc(((100vw - 854px) / 2) - 32px);
  margin-right: 12px;
  font-weight: 600;
  font-size: 16px;
}
</style>
